import Logger from '../Logger/Logger';
import { Messages } from './types/message';
export class CacheHandler {
  private cache = new Map<string, boolean>();
  static instance: CacheHandler;
  loggerServiceInstance = Logger.getInstance();

  private constructor() {
    this.loggerServiceInstance.info(Messages.info.I001);
  }

  public static getInstance(): CacheHandler {
    if (!CacheHandler.instance) {
      CacheHandler.instance = new CacheHandler();
    }
    return CacheHandler.instance;
  }

  /**
   * set url in an array
   * @param url string
   */
  pushUrl(url: string) {
    this.cache.set(url, true);
  }

  /**
   * check weather url present in an array
   * @param url string
   * @returns booelan true/false
   */
  hasUrl(url: string): boolean {
    return this.cache.has(url);
  }

  /**
   * remove items from array
   * @param url string
   */
  remove(url: string) {
    this.cache.delete(url);
  }

  /**
   * check cached URLs
   * DEBUGGING puposes
   */
  entries() {
    this.loggerServiceInstance.info(Messages.info.I002, this.cache);
  }
}
